import REVISION_FILE from "../test/revision.json"
/**
 * リビジョン管理用のローカルストレージ保存関数
 */
function setLocalStorageRevision(obj) {
    localStorage.setItem('REVISION', JSON.stringify(Object.assign({}, JSON.parse(localStorage.getItem('REVISION')), obj)))
}
  
/**
 * リビジョン管理用のローカルストレージ取得関数
 */
function getLocalStorageRevision(key) {
    if (!JSON.parse(localStorage.getItem('REVISION')) || !JSON.parse(localStorage.getItem('REVISION'))[ key ]) {
        return false;
    }
    return JSON.parse(localStorage.getItem('REVISION'))[ key ]
}
/**
 * リビジョンチェック関数
 */
function checkRevision() {
    return new Promise( (resolve) => {
            // リビジョンが不一致：画面強制リロード実施
            if (window.REVISION !== REVISION_FILE.REVISION) {
                // 無限リロードしないようにリロード中かどうかのフラグ情報参照
                let reloadingFlg = getLocalStorageRevision('RELOADING_FLG');
                // リロード中でなければ強制リロード実施
                if(!reloadingFlg) {
                    // 強制リロード中のためフラグをON
                    setLocalStorageRevision({ RELOADING_FLG: true});
                    window.location.reload();
                }
            } else {
                // リビジョンが一致：Local Storageの強制リロード中フラグをfalseにする
                setLocalStorageRevision({ RELOADING_FLG: false});
            }
            resolve("");
        }).finally(
            // JSONパースでエラーが起きてもRejectしない
        );
}
export { checkRevision, setLocalStorageRevision, getLocalStorageRevision };